import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "./index";

export const selectProfile = (state: RootState) => state.profile;
export const selectSettings = (state: RootState) => state.settings;
export const selectRecentSearches = (state: RootState) => state.recentSearches.items;
export const selectBookingDraft = (state: RootState) => state.bookingDraft;
export const selectSearchContext = (state: RootState) => state.searchContext;
export const selectSelectedSuppliers = (state: RootState) =>
  state.selectedSuppliers;
export const selectUi = (state: RootState) => state.ui;

export const selectIsOnboarded = createSelector(
  selectProfile,
  (profile) => Boolean(profile.onboardingCompletedAt && profile.agencyName),
);

export const selectAgencyDisplayName = createSelector(
  selectProfile,
  (profile) => profile.agencyName || "Agenzia",
);

export const selectClienteleSum = createSelector(selectProfile, (profile) => {
  const m = profile.clienteleMix;
  return m.couples + m.families + m.business + m.luxury;
});

export const selectActiveToasts = createSelector(selectUi, (ui) => ui.toasts);
